import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;

  width: 100%;
  background-color: #f4f4f4;
  border-radius: 0.5rem;
  min-height: 25rem;
`;

